import { configureStore } from './configureStore';
var store = configureStore(window.__PRELOADED_STATE__);
if (window) {
    window.__STORE = store;
}
export default store;
